import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/pro-light-svg-icons';

interface FileUploadSuccessProps {
    fileName: string;
    fileSize: number;
    completed: boolean;
}

const PROGRESSBAR_ANIMATION_DURATION_MS = 3000;

export const FileUploadSuccess = ({ fileName, fileSize, completed }: FileUploadSuccessProps) => {
    const [progress, setProgress] = useState(0);
    const [progressColor, setProgressColor] = useState('bg-gradient-to-r from-white to-brand');

    useEffect(() => {
        if (completed) {
            setProgress(100);
            setProgressColor('bg-success');
            return;
        }

        const timer = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                    clearInterval(timer);
                    setProgressColor('bg-success');
                    return 100;
                }
                return prevProgress + 1;
            });
        }, PROGRESSBAR_ANIMATION_DURATION_MS / 100);

        return () => {
            clearInterval(timer);
        };
    }, [completed]);

    const formatFileSize = (size: number) => {
        return size < 1000000
            ? `${(size / 1000).toFixed(1)} KB`
            : `${(size / 1000000).toFixed(1)} MB`;
    };

    return (
        <div className="w-full h-18 bg-white border border-grey-light relative rounded-lg">
            <div className="flex items-center px-2 pt-2 pb-5">
                <div className="w-10 h-10 p-3 bg-white border border-grey-light rounded-md flex items-center justify-center">
                    <FontAwesomeIcon icon={faFileCsv} className="text-success text-xl" />
                </div>

                <div className="ml-4">
                    <p className="text-base">{fileName}</p>
                    <p className="text-sm text-grey-medium">{formatFileSize(fileSize)}</p>
                </div>

                <div className="ml-auto mt-auto flex items-end text-sm text-grey-2">
                    {progress}%
                </div>
            </div>

            <div className="h-1 bg-grey-lighter absolute left-2 right-2 bottom-2">
                <div
                    className={`h-1 ${progressColor} absolute rounded-lg left-0 bottom-0 transition-all ease-in-out`}
                    style={{
                        width: `${completed || progress > 0 ? 100 : 0}%`,
                        transitionDuration: completed || progress > 99 ? '0.5s' : '3s',
                    }}
                ></div>
            </div>
        </div>
    );
};

export default FileUploadSuccess;
